import dispatcher from '../dispatcher';
import cursorStore from '../events/cursor.store';
import * as utils from '../utils';

var elementProto = Object.create(HTMLElement.prototype);

var _handleMouseenter = function(e) {
	var x, y, d, scale;
	var w, h;
	var box;
	var self = this;

	this._to = setTimeout(function() {
		var carousel = self.closest('.carousel');
		var item = self.closest('.item');
		var index = item.getAttribute('data-index');
		var elements = carousel.querySelectorAll('.item[data-index="' + index + '"]');

		Array.prototype.forEach.call(elements, function(el) {
			var img = el.getElementsByClassName('img')[0];
			img.classList.add('hover');
		});
		// x = cursorStore.getData().screenX;
		// y = cursorStore.getData().screenY;

		// d, scale;

		// box = self.getBoundingClientRect();
		// w = box.width;
		// h = box.height;

		// if (!e.clientX) {
		// 	x = w / 2;
		// 	y = h / 2;
		// } else {
		// 	x = x - box.left;
		// 	y = y - box.top;
		// }



		// if (x < 50) {
		// 	x = 0;
		// } else if (w - x < 50) {
		// 	x = w;
		// }
		// if (y < 50) {
		// 	y = 0;
		// } else if (h - y < 50) {
		// 	y = h;
		// }

		// d = Math.pow(Math.pow(w, 2) + Math.pow(h, 2), 0.5);
		// scale = d / self._bw * 2;


		// self._b.style.transform = 'scale(' + scale + ')  translateZ(0px)';
		// self._b.style.left = x - self._bw / 2 + 'px';
		// self._b.style.top = y - self._bh / 2 + 'px';
	}, 300);
}

var _handleMouseleave = function(e) {
	var carousel = this.closest('.carousel');
	var item = this.closest('.item');
	var index = item.getAttribute('data-index');
	var elements = carousel.querySelectorAll('.item[data-index="' + index + '"]');

	Array.prototype.forEach.call(elements, function(el) {
		var img = el.getElementsByClassName('img')[0];
		img.classList.remove('hover');
	});

	clearTimeout(this._to);
	// this.classList.remove('hover');
	// this._b.style.transform = 'scale(' + 0.5 + ')  translateZ(0px)';
}


elementProto.createdCallback = function() {
	// this._bw = 500;
	// this._bh = 500;

	this.handleMouseenter = _handleMouseenter.bind(this);
	this.handleMouseleave = _handleMouseleave.bind(this);
}
elementProto.attachedCallback = function() {
	this._b = this.getElementsByClassName('b')[0];
	this.setAttribute('tabindex', '0');

	if (Modernizr.touchevents) {
		this.addEventListener('click', this.handleMouseenter);
	} else {
		this.addEventListener('mouseenter', this.handleMouseenter, { passive: true });
		this.addEventListener('mouseleave', this.handleMouseleave, { passive: true });
	}

	this.addEventListener('focus', this.handleMouseenter);
	this.addEventListener('blur', this.handleMouseleave);
}
elementProto.detachedCallback = function() {
}

document.registerElement('team-component', {
	prototype: elementProto
});